import { lalSegmentStatus } from '@openx/types/segments';
import { firstLetterUppercase } from '@openx/utils/lib/firstLetterUppercase';

export function mapStatus(apiStatus?: string | null): {
  label: string;
  status: string;
} | null {
  if (apiStatus) {
    const label = apiStatus
      .split('_')
      .map(value => firstLetterUppercase(value))
      .join(' ');
    if (lalSegmentStatus.READY === apiStatus) {
      return {
        label,
        status: 'active',
      };
    } else if (lalSegmentStatus.ERROR === apiStatus) {
      return {
        label,
        status: 'error',
      };
    } else if (lalSegmentStatus.EXPIRED === apiStatus) {
      return {
        label,
        status: 'warning',
      };
    } else if (lalSegmentStatus.PROCESSING === apiStatus) {
      return {
        label,
        status: 'processing',
      };
    } else {
      return {
        label,
        status: 'inactive',
      };
    }
  } else {
    return null;
  }
}
